import { Image, StyleSheet, View } from '@react-pdf/renderer';
import logo from '../../../assets/image/system/logo.png';

const styles = StyleSheet.create({
  header: { flexDirection: 'row', alignItems: 'center', marginBottom: 10 },
  logo: { height: 24, width: 'auto' },
});

export const ReportPdfLogo = () => (
  <View style={styles.header}>
    <Image src={logo} style={styles.logo} />
  </View>
);
